import { Component, ViewChild } from '@angular/core';

import { HeaderComponent } from './header/header.component';

import '../assets/app.css';
import { GlobalValues } from './common/_common';
import { PlatformLocation } from '@angular/common';

@Component({
  moduleId: module.id.toString(),
  // tslint:disable-next-line:component-selector
  selector: 'app',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild(HeaderComponent) private header: HeaderComponent;
  constructor(
    private platformLocation: PlatformLocation
  ) { }

  public onRouterOutletActivate(event: any) {
   
    // else{
    //   localStorage.removeItem("availabilityStoredFilter");/iTradePortal_V3/UI/login  /iTradePortal/V13/UI/
    // }
    if (this.platformLocation.pathname == "/login" || this.platformLocation.pathname == "/adminlogin") {
      GlobalValues.isLoggedIn = false;
      this.header.isLoggedIn = false;
      localStorage.removeItem('currentUser');
      localStorage.removeItem('currentAdminUser');
      localStorage.removeItem("customer");
      localStorage.removeItem("UserType");

    }
    if (this.platformLocation.pathname == "/" || this.platformLocation.pathname == "/login" || this.platformLocation.pathname == "/") {
      localStorage.removeItem('availabilityStoredFilter');
      localStorage.removeItem('storedFilter');
      localStorage.removeItem("UserType");
      localStorage.removeItem("customer");
    }
   
    if (GlobalValues.isLoggedIn == true) {
      this.header.isLoggedIn = true;
      if (localStorage.getItem("currentUser")) {
        this.header.userrole = true;
        var name: any = localStorage.getItem("currentUser");
        name = JSON.parse(name);
        this.header.username = name.username;
      }
      if (localStorage.getItem("currentAdminUser")) {
        this.header.adminrole = true;
        var name: any = localStorage.getItem("currentAdminUser");
        name = JSON.parse(name);
        this.header.username = name.username;
      }
    }
    if(this.platformLocation.pathname == "/" || this.platformLocation.pathname == "/login" || this.platformLocation.pathname == "/" ){
      localStorage.removeItem('availabilityStoredFilter');
      localStorage.removeItem('storedFilter');
      localStorage.removeItem("customer");
      localStorage.removeItem("UserType");
    }
    if (this.platformLocation.pathname == "/userdetail" || this.platformLocation.pathname == "/portaluserprofile") {
      // localStorage.removeItem('userdetail') /iTradePortal/V7/UI/adminlogin
    }
    else {
      localStorage.removeItem('userdetail')
    }
    if (this.platformLocation.pathname == "/availability" || this.platformLocation.pathname == "/" || this.platformLocation.pathname == "/" || this.platformLocation.pathname == "/") {
      localStorage.removeItem('viewDetail')
    
    } else {
    
      // /iTradePortal/V6/UI
    }
   
    // if (
    //   this.platformLocation.pathname != "/buycontainer" &&
    //   this.platformLocation.pathname != "/iTradePortal/V13/UI/viewdetails/" 
    // ) {
    //   localStorage.removeItem("storedFilter");
    // }
    // console.log(this.platformLocation.pathname);
    // if (
    //   this.platformLocation.pathname != "/iTradePortal/V13/UI/availability" &&
    //   this.platformLocation.pathname != "/iTradePortal/V13/UI/availability-viewdetail"
    // ) {
    //   localStorage.removeItem("availabilityStoredFilter");
    // }
   

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts